import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles({
  selectMenu: {
    whiteSpace: "normal",
  },

  menuItem: {
    whiteSpace: "normal",
    height: "auto",
    minHeight: 48,
  },
  formControl: {
    width: "100%",
  },
  dropDown: {
    border: 0,
    "&:hover": {
      border: (props) => `1px solid ${props.currentTheme.primaryColor}`,
    },
  },
});

export default useStyles;
